export type ThemeMode = 'light' | 'dark';

export const THEME_STORAGE_KEY = 'jo-theme';
export const DEFAULT_THEME: ThemeMode = 'light';

export const resolveTheme = (stored: string | null): ThemeMode => {
  return stored === 'dark' ? 'dark' : DEFAULT_THEME;
};

export const getStoredTheme = (): ThemeMode => {
  if (typeof window === 'undefined') {
    return DEFAULT_THEME;
  }

  return resolveTheme(window.localStorage.getItem(THEME_STORAGE_KEY));
};

export const applyTheme = (theme: ThemeMode): void => {
  document.documentElement.setAttribute('data-theme', theme);
  document.documentElement.style.colorScheme = theme;

  const metaTheme = document.querySelector('meta[name="theme-color"]');
  if (metaTheme) {
    metaTheme.setAttribute('content', theme === 'dark' ? '#0f172a' : '#0284C7');
  }
};

export const persistTheme = (theme: ThemeMode): void => {
  window.localStorage.setItem(THEME_STORAGE_KEY, theme);
  applyTheme(theme);
};
